import { Extent as olExtent, createEmpty, extend } from "ol/extent";
import olFeature from "ol/Feature";
import olInteraction from "ol/interaction/Interaction";
import olMapBrowserEvent from "ol/MapBrowserEvent";
import olPluggableMap from "ol/PluggableMap";

export interface ZoomToClusterProps {
  hitTolerance?: number
}

class ZoomToCluster extends olInteraction {
  private _hitTolerance: number;

  constructor({ hitTolerance}: ZoomToClusterProps) {
    super();
    this._hitTolerance = hitTolerance ?? 0;
  }

  public setMap(map: olPluggableMap) {
    const currentMap = this.getMap();
    if (currentMap) {
      currentMap.un("click", this.handleClick);
    }
    super.setMap(map);
    if (map) {
      map.on("click", this.handleClick);
    }
  }

  public getHitTolerance() {
    return this._hitTolerance;
  }

  public setHitTolerance(value?: number) {
    this._hitTolerance = value ?? 0;
  }

  private handleClick = (e: olMapBrowserEvent<any>) => {
    if (e.map === null) return;
    
    // If any features were clicked
    const clickedFeatures = e.map.getFeaturesAtPixel(
      e.pixel, 
      { hitTolerance: this.getHitTolerance()}) as olFeature[];
    if (!clickedFeatures.length ) return;

    // Filter the selected features to only the clustered ones 
    // where the cluster isn't a single feature
    // and get the features within the cluster
    const features = clickedFeatures
    .filter(f => f.getKeys().some(k => k === "features"))
    .map(f => f.get("features") as olFeature[])
    .filter(c => c.length > 1)
    .flatMap(f => f);    
    if (!features.length) return;

    // Build an extent of all of the features in the selected clusters
    const extent = createEmpty();
    features
      .map(f => f.getGeometry()?.getExtent())
      .filter(e => e !== undefined)
      .map(e => e as olExtent)
      .forEach(e =>  extend(extent, e));

    // Animate the zoom to that extent
    e.map
      .getView()
      .fit(extent, {
        duration: 1000,
        padding: [50, 50, 50, 50],
      });
    
  }
}

export default ZoomToCluster;
